import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  margin-top: 4px;
  position: relative;
  flex-shrink: 2;
  max-height: 45px;
`;

export default Container;
